import { LogoIcon } from "./Icons";
import {useTranslation} from "react-i18next";

export const Footer = () => {
  const {t} = useTranslation();

  return (
      <footer className="px-16 pt-16 mt-12 min-w-screen text-white bg-charcoal">
        <div className="grid gap-2 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4 text-white">
          <div className="sm:col-span-2">
            <a
                href="/"
                aria-label="Go home"
                title="DIVERT Mental Health Homepage"
                className="inline-flex items-center text-white"
            >
              <LogoIcon color={"#fff"}/>
            </a>
          </div>
          <div className="space-y-2 text-sm text-white">
            <p className="text-base font-bold tracking-wide text-white">
              DIVERT Mental Health
            </p>
            <div className="space-y-1">
              <span className="block text-white">2006 Sherman Health Science Research Centre</span>
              <span className="block text-white">281 Ian MacDonald Blvd</span>
              <span className="block text-white">York University</span>
              <span className="block text-white">Toronto, Ontario M3J 3M4</span>
              <span className="block text-white">416 736 2100 ext. 20177</span>
            </div>
          </div>
          <div className="text-sm space-y-1 text-white">
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/about/">{t("landing.aboutUs")}</a>
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/partnerships/">{t("landing.partnerships")}</a>
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/become-a-member/">{t("landing.becomeAMember")}</a>
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/alreadyamember/">{t("landing.alreadyAMember")}</a>
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/events/">{t("landing.events")}</a>
            <a className="block text-white hover:text-gray-200 transition-colors" href="https://divertmentalhealth.ca/contact/">{t("landing.contactUs")}</a>
          </div>
        </div>
        <div className="flex flex-col-reverse justify-between pt-5 pb-10 border-t border-white/20 lg:flex-row text-white">
          <p className="text-sm text-white">
            &copy; 2026 DIVERT Mental Health. {t("landing.allRightsReserved")}
          </p>
          <ul className="flex mb-3 lg:mb-0 space-y-0 space-x-5 flex-row">
            <li>
              <a
                  href="https://twitter.com/DIVERT_mhsm"
                  className="!text-white transition-colors duration-300 hover:!text-springGreen"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 !text-white">
                  <path
                      d="M24,4.6c-0.9,0.4-1.8,0.7-2.8,0.8c1-0.6,1.8-1.6,2.2-2.7c-1,0.6-2,1-3.1,1.2c-0.9-1-2.2-1.6-3.6-1.6 c-2.7,0-4.9,2.2-4.9,4.9c0,0.4,0,0.8,0.1,1.1C7.7,8.1,4.1,6.1,1.7,3.1C1.2,3.9,1,4.7,1,5.6c0,1.7,0.9,3.2,2.2,4.1 C2.4,9.7,1.6,9.5,1,9.1c0,0,0,0,0,0.1c0,2.4,1.7,4.4,3.9,4.8c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6,0-0.9-0.1c0.6,2,2.4,3.4,4.6,3.4 c-1.7,1.3-3.8,2.1-6.1,2.1c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.8,2.2,7.5,2.2c9.1,0,14-7.5,14-14c0-0.2,0-0.4,0-0.6 C22.5,6.4,23.3,5.5,24,4.6z"/>
                </svg>
              </a>
            </li>
            <li>
              <a
                  href="https://www.linkedin.com/company/divert-mhsm/"
                  className="!text-white transition-colors duration-300 hover:!text-springGreen"
              >
                <svg viewBox="0 0 30 30" fill="currentColor" className="h-6 !text-white">
                  <circle cx="15" cy="15" r="4"/>
                  <path
                      d="M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10   C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1   c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z"/>
                </svg>
              </a>
            </li>
            <li>
              <a
                  href="https://www.instagram.com/divert_mhsm/"
                  className="!text-white transition-colors duration-300 hover:!text-springGreen"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 !text-white">
                  <path
                      d="M22,0H2C0.895,0,0,0.895,0,2v20c0,1.105,0.895,2,2,2h11v-9h-3v-4h3V8.413c0-3.1,1.893-4.788,4.659-4.788 c1.325,0,2.463,0.099,2.795,0.143v3.24l-1.918,0.001c-1.504,0-1.795,0.715-1.795,1.763V11h4.44l-1,4h-3.44v9H22c1.105,0,2-0.895,2-2 V2C24,0.895,23.105,0,22,0z"/>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </footer>
  );
};
